<!--<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">-->

<nav class="toolbar navbar navbar-light">
    <div class="form-inline">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>

        <button *ngIf="!visibilitySpinner" [disabled]="!habilitarEnviar" type="button" class="btn btn-outline-success" (click)="enviarSolicitud()"><i class="fa fa-envelope-o"></i> Enviar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" type="button" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Enviando
        </button>
    </div>
</nav>

<div class="animated fadeIn container-fluid">
    <div>
        <h5 *ngIf="codigo !== null" style="display:inline">Código de Solicitud: {{codigo}}</h5>
        <h5 *ngIf="codigo !== null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{solicitudCpe.IdEstado | IconoEstadoSolicitudCpe}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>
        <h5 *ngIf="codigo === null" style="display:inline">Solicitud </h5>
        <h5 *ngIf="codigo === null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{solicitudCpe.IdEstado | IconoEstadoSolicitudCpe}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>
    </div>

    <!--<div *ngIf="fechaSolicitud != null">
        <h5>Fecha de Envío: {{fechaSolicitud}}</h5>
    </div>-->
    <!--ICONO CHECK LISTA PARA ENVIO-->
    <div *ngIf="visibilityCheckEnvio" style="margin-top: 10px;">
        <h5 style="display:inline">
            <span>
                <img class="check-envio" src="{{ true | IconoCheckEnvio}}" />
            </span>
        </h5>
        <h5 style="display:inline"> La solicitud está lista para ser enviada</h5>
    </div>

    <div class="row">
        <div class="col-md-12">
            <!--Validaciones propias de la solicitud-->
            <table *ngIf="validacionCollection !== null && validacionCollection.length > 0 && !visibilityCheckEnvio" class="table table-responsive table-sm">
                <tbody>
                    <tr *ngFor="let item of validacionCollection">
                        <td class="empty-grid">{{item}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<form [formGroup]="form" autocomplete="off">
    <div class="animated fadeIn container-fluid" style="padding-top: 0.3rem !important;">
        <div class="row">
            <div class="col-md-12">
                <!--DATOS DEL ENVíO DE LA SOLICITUD-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosEnvio = !isCollapsedDatosEnvio" [attr.aria-expanded]="!isCollapsedDatosEnvio" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos del envío de la solicitud
                            <i *ngIf="isCollapsedDatosEnvio" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosEnvio" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedDatosEnvio" [ngbCollapse]="isCollapsedDatosEnvio">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Envío: </label>
                                    <input formControlName="FechaEnvio" name="FechaEnvio" disabled title="" class="form-control" id="" value="">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Número de Solicitud: </label>
                                    <input formControlName="Codigo" name="Codigo" disabled title="" class="form-control" id="" type="text" value="">
                                </div>
                                <!--<div class="col-md-3" style="padding-top: 40px;">
                                    <div class="form-group-0 float-right">

                                        <div class="btn-group">-->
                                <!--<button name="btnSearch" class="btn btn-secondary btn-sm " type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Enviar</button>-->
                                <!--<button *ngIf="!visibilitySpinnerEnviar" [disabled]="!habilitarEnviar" type="button" class="btn btn-secondary btn-sm" (click)="enviarSolicitud()"><i class="fa fa-envelope-o"></i> {{tituloBoton}}</button>
                                            <button *ngIf="visibilitySpinnerEnviar" [disabled]="true" type="button" class="btn btn-secondary btn-sm" style="color:white !important">
                                                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                Enviando
                                            </button>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- DATOS CERTIFICADO -->
        <div class="row" *ngIf="form.value.Codigo !== null">
            <div class="col-md-12">
                <!--DATOS SEDE -->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosCPE = !isCollapsedDatosCPE" [attr.aria-expanded]="!isCollapsedDatosCPE" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Certificado Previo Exportación
                            <i *ngIf="isCollapsedDatosCF" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosCF" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros-cf" id="collapsedDatosCPE" [ngbCollapse]="isCollapsedDatosCPE">
                            <div class="row" *ngIf="solicitudCpe.NumeroCertificado !== null">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Certificación: </label>
                                    <input formControlName="FechaCertificacion" name="FechaCertificacion" disabled title="" class="form-control" id="" value="">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Número de Certificado: </label>
                                    <input formControlName="NumeroCertificado" name="NumeroCertificado" disabled title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="col-md-6" style="padding-top: 40px;">
                                    <div class="form-group-0 float-right">
                                        <div class="btn-group">
                                            <button *ngIf="!visibilitySpinnerPrintCPE" [disabled]="!habilitarPrintCPE" name="btnPrintCPE" class="btn btn-descarga btn-secondary btn-sm " type="button" title="Certificado Previo Exportación" (click)="onPrintCPE()">
                                                <i class="fa fa-file-pdf-o"></i> Generar CPE
                                            </button>
                                            <button *ngIf="visibilitySpinnerPrintCPE" [disabled]="true" class="btn btn-secondary btn-sm">
                                                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                Generando CPE
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="solicitudCpe.NumeroCertificado === null">
                                <div class="form-group col-md-9" style="margin-bottom: 0px !important;">
                                    <label class="col-form-label" style="top: 12px;"><b>Certificado Previo Exportación pendiente de aprobación y emisión </b></label>
                                </div>
                                <!--<div class="col-md-3" style="padding-top: 5px;">
                                    <div class="form-group-0 float-right">
                                        <div class="btn-group">-->
                                <!--<button name="btnEmitirCF" class="btn btn-secondary btn-sm" type="button" title="Emitir Certificado Fitosanitario" (click)="onEmitirCF()"><i class="fa fa-file-text-o"></i> Emitir CF</button>-->
                                <!-- Ya veremos *ngIf-->
                                <!--<button *ngIf="!visibilitySpinnerEmitirCF" [disabled]="!habilitarEmitirCF" title="Emitir Certificado Fitosanitario" type="button" class="btn btn-secondary btn-sm" (click)="onEmitirCF()">
                                    <i class="fa fa-leaf"></i> Emitir Certificado Fitosanitario
                                </button>-->
                                <!-- -->
                                <!--<button *ngIf="visibilitySpinnerEmitirCF" [disabled]="true" class="btn btn-secondary btn-sm">
                                                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                                                Generando Informe
                                            </button>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
